.bn{outline:none;}